import { API_V1 } from '../api';
import { UrlInfo } from './UrlInfoModel';

export async function verifyUrl(url: string): Promise<UrlInfo> {
	const { data } = await API_V1.get('/url/verify', { params: { url } });
	return data as UrlInfo;
}
